
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"129","height":"69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"width":"129","height":"69","transform":"translate(1275 651)","fill":"#fff","stroke":"#707070"}})])]),_c('path',{attrs:{"d":"M37.267 52.584a7.3 7.3 0 009.323 5.666 7.445 7.445 0 01-9.323-5.666z","fill":"#4a93ec"}}),_c('path',{attrs:{"d":"M50.958 47.195l10.556-18.308-3.106-1.791a10.674 10.674 0 1115.438-5.812l7 1.663a17.846 17.846 0 10-28.944 8.256l-7.159 12.4a7.452 7.452 0 016.215 3.592z","fill":"#eceef2"}}),_c('path',{attrs:{"d":"M97.079 38.398a17.845 17.845 0 00-18.774-3.936l-7.72-12.228a7.458 7.458 0 01-6.091 3.787l11.382 18.028 3.032-1.914a10.674 10.674 0 11-2.049 16.368l-4.73 5.418a17.846 17.846 0 0024.95-25.523z","fill":"#eceef2"}}),_c('path',{attrs:{"d":"M75.888 51.063a7.428 7.428 0 01.889-3.534l-21.253.027v3.585a10.674 10.674 0 11-12.76-10.454L40.7 33.798A17.847 17.847 0 1062.339 54.72l14.5-.019a7.431 7.431 0 01-.951-3.638z","fill":"#eceef2"}}),_c('path',{attrs:{"d":"M70.585 22.234l-.093-.147a7.345 7.345 0 10-12.665.411v.006a7.341 7.341 0 006.6 3.413l.066.1a7.458 7.458 0 006.092-3.783z","fill":"#f9487f"}}),_c('path',{attrs:{"d":"M83.373 43.762z","fill":"#423f5a"}}),_c('path',{attrs:{"d":"M76.836 54.701h.137a7.349 7.349 0 10-.005-7.172h-.191a7.461 7.461 0 00.059 7.172zM44.743 43.604l-.16.278a7.345 7.345 0 00-7.316 8.7 7.445 7.445 0 009.323 5.666 7.335 7.335 0 004.258-3.354h.007a7.342 7.342 0 00-.054-7.431l.157-.273a7.452 7.452 0 00-6.215-3.586z","fill":"#f9487f"}})])
          )
        }
      }
    